import * as currencies from '@dinero.js/currencies';
import dinero from 'dinero.js';

export const money = (
  amount,
  currencyCode = 'USD',
  flagEvCurrenciesWithoutCents = false,
) => ({
  total: amount,
  cents: flagEvCurrenciesWithoutCents
    ? dinero({
        amount: 10 ** currencies[currencyCode].exponent * amount.toFixed(2),
        currency: currencies[currencyCode],
        precision: currencies[currencyCode].exponent,
      }).getAmount()
    : Math.round(Number(amount) * 100),
});

export const moneyFromCents = (
  cents,
  currencyCode = 'USD',
  flagEvCurrenciesWithoutCents = false,
) => ({
  total: flagEvCurrenciesWithoutCents
    ? dinero({
        amount: cents,
        currency: currencies[currencyCode],
        precision: currencies[currencyCode].exponent,
      }).toUnit()
    : cents / 100,
  cents,
});

export const validateCents = (selectedCurrency, setHasCents) => {
  if (selectedCurrency.has_cents) {
    setHasCents(true);
  } else {
    setHasCents(false);
  }
};
